import { motion } from "framer-motion";
import { ExternalLink, Linkedin, Mail } from "lucide-react";
import Logo from "@/components/Logo";
import { EMAIL, LINKS } from "@/content/story";

export const Footer = () => (
    <footer className="relative z-10 border-t border-white/50 bg-cream/50 px-6 py-9 backdrop-blur-xl">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="mx-auto flex max-w-6xl flex-col items-center gap-6 sm:flex-row sm:justify-between"
        >
            <div className="flex items-center gap-2.5">
                <Logo className="h-7 w-7" />
                <span className="font-display text-lg font-semibold tracking-tight text-ink">
                    Roots <span className="italic text-terracotta">&amp;</span> Routes
                </span>
            </div>

            <div className="flex flex-col items-center gap-3">
                <p data-testid="footer-more-coming" className="font-mono text-[10px] uppercase tracking-[0.24em] text-inksoft">
                    The next chapters are still being written
                </p>
                <div className="flex flex-wrap items-center justify-center gap-3">
                    <a
                        data-testid="footer-email-button"
                        href={`mailto:${EMAIL}?subject=Hi%20Arpit%2C%20loved%20the%20story`}
                        className="flex items-center gap-2 rounded-full bg-terracotta px-5 py-2.5 text-xs font-semibold text-cream transition-transform duration-300 hover:scale-105"
                    >
                        <Mail size={14} />
                        Email me
                    </a>
                    <a
                        data-testid="footer-craftedspaces-link"
                        href={LINKS.craftedspaces}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-1.5 rounded-full border border-line bg-white/60 px-4 py-2.5 text-xs font-semibold text-inksoft transition-colors duration-300 hover:border-terracotta hover:text-terracotta"
                    >
                        craftedspace.shop
                        <ExternalLink size={12} />
                    </a>
                    <a
                        data-testid="footer-linkedin-link"
                        href={LINKS.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-1.5 rounded-full border border-line bg-white/60 px-4 py-2.5 text-xs font-semibold text-inksoft transition-colors duration-300 hover:border-terracotta hover:text-terracotta"
                    >
                        LinkedIn
                        <Linkedin size={12} />
                    </a>
                </div>
            </div>

            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-inkfaint">
                Arpit Shukla · Developer — a village in UP
            </p>
        </motion.div>
    </footer>
);

export default Footer;
